import { Card, CardBody, CardHeader } from '../../../components/ui/Card';
import { PageContainer, PageHeader } from '../../../components/ui/Page';
import { BrandingForm } from '../components/BrandingForm';
import { PreferencesForm } from '../components/PreferencesForm';
import { ProfileForm } from '../components/ProfileForm';

export function BusinessSettingsPage() {
  return (
    <PageContainer width="md">
      <PageHeader title="Business settings" description="Profile, locale, working hours and team rules." />
      <div className="space-y-6">
        <Card>
          <CardHeader title="Business profile" />
          <CardBody>
            <ProfileForm />
          </CardBody>
        </Card>
        <Card>
          <CardHeader title="Locale and hours" description="Used for due times, reminders and reports." />
          <CardBody>
            <PreferencesForm />
          </CardBody>
        </Card>
      </div>
    </PageContainer>
  );
}

export function BrandingPage() {
  return (
    <PageContainer>
      <PageHeader
        title="Branding"
        description="Your logo and colours appear in the app, the staff app and emails to staff."
      />
      <Card>
        <CardBody>
          <BrandingForm />
        </CardBody>
      </Card>
    </PageContainer>
  );
}
